import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { useState } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { LinkAnimation, ListUserAttendance, MobileDialogCampusCalendarCheckinAddCheckin, MobileDialogCampusCalendarCheckinInjured, MobileDialogCampusCalendarCheckinSelectTypeCheckin, SwitchStatus, MobileContainerAnimation } from "../../../../../";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import AddLocationIcon from "@material-ui/icons/AddLocation";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      minHeight: "100%"
    },
    breadcrumb: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      height: "60px",
      position: "fixed",
      width: "100%",
      background: theme.palette.background["default"]
    },
    containerIcon: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "80px",
      marginTop: "60px",
      position: "fixed",
      width: "100%",
      background: theme.palette.background["default"]
    },
    textFlexWidth: {
      flexGrow: "1",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    content: {
      padding: "140px 8px 8px 8px",
      width: "100%"
    },
    textAnimation7s: {
      display: "inline-block",
      animation: "$animate 7s linear 2s alternate infinite"
    },
    "@keyframes animate": {
      "0%": {
        transform: "translateX(0%)"
      },
      "25%": {
        transform: "translateX(0%)"
      },
      "75%": {
        transform: "translateX(-80%)"
      },
      "100%": {
        transform: "translateX(-80%)"
      }
    }
  };
});

var MobileCampusCalendarCheckIn = function MobileCampusCalendarCheckIn(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openDialogAddCheckIn = _useState2[0],
      setOpenDialogAddCheckIn = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialogSelectTypeCheckIn = _useState4[0],
      setOpenDialogSelectTypeCheckIn = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openDialogInjuredCheckIn = _useState6[0],
      setOpenDialogInjuredCheckIn = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      userSelected = _useState8[0],
      setUserSelected = _useState8[1];

  var classes = useStyles(); // HANDLE DIALOGS

  var handleDialogAddCheckIn = function handleDialogAddCheckIn() {
    if (openDialogAddCheckIn) {
      setUserSelected(null);
    }

    setOpenDialogAddCheckIn(!openDialogAddCheckIn);
  };

  var handleDialogSelectTypeCheckIn = function handleDialogSelectTypeCheckIn() {
    if (openDialogSelectTypeCheckIn) {
      setUserSelected(null);
    }

    setOpenDialogSelectTypeCheckIn(!openDialogSelectTypeCheckIn);
  };

  var handleDialogInjuredCheckIn = function handleDialogInjuredCheckIn() {
    if (openDialogInjuredCheckIn) {
      setUserSelected(null);
    }

    setOpenDialogInjuredCheckIn(!openDialogInjuredCheckIn);
  }; // HANDLE FUNCTIONS


  var handleClickUser = function handleClickUser(key) {
    var user = props.data ? props.data.attendance ? props.data.attendance.find(function (_user) {
      return _user.key === key;
    }) || null : null : null;

    if (user) {
      setUserSelected(user);

      if (user.status === "injured") {
        handleDialogInjuredCheckIn();
      } else {
        handleDialogSelectTypeCheckIn();
      }
    }
  }; // HANLDE SELECT TYPE CHECKOUT


  var handleSelectTypeCheckIn = function handleSelectTypeCheckIn(option) {
    if (option === "group_change") {
      setOpenDialogSelectTypeCheckIn(false);
      props.data.handleAddCheckIn(_objectSpread(_objectSpread({}, userSelected), {}, {
        status: "attended",
        checkin: {
          date: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
          responsible: {
            id: null,
            name: null
          },
          done: true,
          type: "group_change"
        }
      }));
    } else if (option === "entry") {
      setOpenDialogSelectTypeCheckIn(false);
      handleDialogAddCheckIn();
    }
  }; // --- HANDLE INJURED --- //
  // USER CONTINUES INJURED


  var handleInjuredSaysYes = function handleInjuredSaysYes() {
    props.data.handleAddCheckIn(_objectSpread(_objectSpread({}, userSelected), {}, {
      status: "not_attended",
      checkin: {
        date: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
        done: true
      }
    }));
    handleDialogInjuredCheckIn();
  }; // USER DISCONTINUES INJURED


  var handleInjuredSaysNo = function handleInjuredSaysNo() {
    setOpenDialogInjuredCheckIn(false);
    handleDialogAddCheckIn();
  };

  return /*#__PURE__*/React.createElement(MobileContainerAnimation, Object.assign({
    classes: classes.root
  }, props.routerState || null), /*#__PURE__*/React.createElement(MobileDialogCampusCalendarCheckinAddCheckin, {
    open: openDialogAddCheckIn,
    onClose: handleDialogAddCheckIn,
    data: userSelected,
    onSubmit: props.data ? props.data.handleAddCheckIn : null,
    translation: props.translation
  }), /*#__PURE__*/React.createElement(MobileDialogCampusCalendarCheckinSelectTypeCheckin, {
    open: openDialogSelectTypeCheckIn,
    onClose: handleDialogSelectTypeCheckIn,
    handleSelectOption: handleSelectTypeCheckIn,
    data: userSelected,
    translation: props.translation
  }), /*#__PURE__*/React.createElement(MobileDialogCampusCalendarCheckinInjured, {
    open: openDialogInjuredCheckIn,
    onClose: handleDialogInjuredCheckIn,
    handleYes: handleInjuredSaysYes,
    handleNo: handleInjuredSaysNo,
    translation: props.translation
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumb
  }, /*#__PURE__*/React.createElement(LinkAnimation, props.link, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    fontSize: "large"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textFlexWidth
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.textAnimation7s
  }, props.groupName || ""))), /*#__PURE__*/React.createElement("div", {
    className: classes.containerIcon
  }, /*#__PURE__*/React.createElement(AddLocationIcon, {
    fontSize: "large",
    color: "primary"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.titles ? props.translation.titles.check_in || "Check in" : "Check in" : "Check in")), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(SwitchStatus, {
    status: props.status,
    action_download: function action_download() {
      props.handleDownloadInfo();
      return null;
    },
    success: function success() {
      return /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(ListUserAttendance, {
        data: props.data ? props.data.attendance || [] : [],
        handleClickUser: handleClickUser
      }));
    }
  })));
};

export { MobileCampusCalendarCheckIn };